import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	amountTitle: 'Amount',
	amount: 'amount',
	rateTitle: 'Indicative exchange rate',
	feesTitle: 'Fees',
	fees: 'Payment fee',
	totalAmountTitle: 'Total amount',
	sentAmountTitle: 'Amount being sent',
	settlementDateTitle: 'Earliest estimated settlement date',
	submissionDateTitle: 'Submission date',
	importantInfoTitle: 'Important information',
	importantInfoDescription:
		'We use live foreign exchange rates to give you an indication of final costs. Your payment will be submitted for approval using an indicative rate – this means the figures highlighted are subject to change before the payment is approved. The exact amounts will be clearly shown when it comes to authorising the payment.',
	extraInfo: 'Please note that any fees you’ve agreed to pay will be taken from your account as a separate payment.',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
